export default __webpack_public_path__ + "static/TragicMarker-4123e1d070941f4da46fb9ba49d5cee3.woff";